export default "__VITE_PUBLIC_ASSET__0e8b24e6__"